<template>
  <div id="pageRoot">
    <img id="bg" class="pageElement" src="/pages/img/sordocas/svgCas21bg.svg" />
    <img id="pencil" class="pageElement" src="/pages/img/sordoglo/svgGlo6Pencil.svg" />

    <span class="normalTheme pageInstruction" style="left: 81px; top: 91px">
      <p>Escribe en orden las palabras para saber qué dice Zorrito.</p>
    </span>
    <p id="tag01" class="textBase basicItem01 tagWhite">los</p>
    <p id="tag02" class="textBase basicItem01 tagWhite">tres!</p>
    <p id="tag03" class="textBase basicItem01 tagWhite">comieron</p>
    <p id="tag04" class="textBase basicItem01 tagWhite">¡Cómo</p>
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
    />
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 0px;
  top: 151px;
}

#tag01 {
  position: absolute;
  width: 190px;
  height: 40px;
  text-align: center;
  left: 410px;
  top: 331px;
}
#tag02 {
  position: absolute;
  width: 190px;
  height: 40px;
  text-align: center;
  left: 660px;
  top: 331px;
}
#tag03 {
  position: absolute;
  width: 190px;
  height: 40px;
  text-align: center;
  left: 410px;
  top: 411px;
}
#tag04 {
  position: absolute;
  width: 190px;
  height: 40px;
  text-align: center;
  left: 660px;
  top: 411px;
}

#inputField01 {
  position: absolute;
  width: 823px;
  left: 130px;
  top: 607px;
  z-index: 2;
}
#pencil {
  position: absolute;
  left: 51px;
  top: 588px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "cas/Video 67.mp4",
        "cas/Video 68.mp4",
      ],
    };
  },
};
</script>